import React, { useRef } from 'react'
import { useGLTF, PerspectiveCamera } from '@react-three/drei'
import pasarela from '../models/pasarela.glb'

export default function Model({ ...props }) {
  const group = useRef()
  const { nodes } = useGLTF(pasarela)
  return (
    <group ref={group} {...props} dispose={null}>
      <group position={[-50, -2.5, 20.4]} scale={0.01} rotation={[-Math.PI / 2, 0, 0]}>
        <group position={[61.12, 32.43, 0]}>
          <group position={[2970.04, 1867.13, 0]}>
            <group position={[947.31, 128.5, 121.82]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
              <mesh geometry={nodes['Concrete_Flooring_H01_2m#1_2'].geometry} material={nodes['Concrete_Flooring_H01_2m#1_2'].material} />
            </group>
            <group position={[570.63, 163.78, 132.23]} rotation={[-Math.PI, -1.45, Math.PI / 2]}>
              <mesh geometry={nodes['Concrete_Flooring_H01_2m#1_3'].geometry} material={nodes['Concrete_Flooring_H01_2m#1_3'].material} />
            </group>
            <group position={[386.8, 1071.25, 108.42]} rotation={[-Math.PI / 2, 0, Math.PI]}>
              <mesh geometry={nodes['Concrete_Flooring_H01_2m#1_4'].geometry} material={nodes['Concrete_Flooring_H01_2m#1_4'].material} />
            </group>
            <group position={[-15.72, 163.78, 61.87]} rotation={[-Math.PI, -1.45, Math.PI / 2]}>
              <mesh geometry={nodes['Concrete_Flooring_H01_2m#1_5'].geometry} material={nodes['Concrete_Flooring_H01_2m#1_5'].material} />
            </group>
            <group position={[310.03, 83.85, 156.05]}>
              <mesh geometry={nodes['Iron_Blurry_5cm#1'].geometry} material={nodes['Iron_Blurry_5cm#1'].material} />
            </group>
            <group position={[306.88, 207.08, 156.05]} rotation={[0, 0, -Math.PI / 2]}>
              <mesh geometry={nodes['Iron_Blurry_5cm#1_1'].geometry} material={nodes['Iron_Blurry_5cm#1_1'].material} />
              <mesh geometry={nodes.Color_M006_2.geometry} material={nodes.Color_M006_2.material} />
            </group>
            <group position={[371.84, 210.23, 156.05]} rotation={[0, 0, Math.PI]}>
              <mesh geometry={nodes['Iron_Blurry_5cm#1_2'].geometry} material={nodes['Iron_Blurry_5cm#1_2'].material} />
              <mesh geometry={nodes.Color_M006_3.geometry} material={nodes.Color_M006_3.material} />
            </group>
            <group position={[-27.92, 224.8, 156.08]} rotation={[0, -1.45, -Math.PI / 2]}>
              <mesh geometry={nodes['Concrete_Flooring_H01_2m#1_6'].geometry} material={nodes['Concrete_Flooring_H01_2m#1_6'].material} />
            </group>
            <group position={[352.05, 126.36, 53.14]} rotation={[-Math.PI / 2, 0, -Math.PI]}>
              <mesh geometry={nodes['Concrete_Flooring_H01_2m#1_7'].geometry} material={nodes['Concrete_Flooring_H01_2m#1_7'].material} />
            </group>
            <group position={[369.08, 128.73, 53.94]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
              <mesh geometry={nodes['Concrete_Flooring_H01_2m#1_8'].geometry} material={nodes['Concrete_Flooring_H01_2m#1_8'].material} />
            </group>
            <group position={[370.84, 83.85, 162.88]}>
              <group position={[351.25, 0, 42.15]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_30'].geometry} material={nodes['Iron_Blurry_5cm#1_30'].material} />
                <mesh geometry={nodes.Color_M006_28.geometry} material={nodes.Color_M006_28.material} />
              </group>
              <group position={[1112.3, 0, 133.48]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_31'].geometry} material={nodes['Iron_Blurry_5cm#1_31'].material} />
                <mesh geometry={nodes.Color_M006_29.geometry} material={nodes.Color_M006_29.material} />
              </group>
              <mesh geometry={nodes['Iron_Blurry_5cm#1_32'].geometry} material={nodes['Iron_Blurry_5cm#1_32'].material} />
              <mesh geometry={nodes.Color_M006_30.geometry} material={nodes.Color_M006_30.material} />
              <group position={[643.96, 0, 77.28]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_33'].geometry} material={nodes['Iron_Blurry_5cm#1_33'].material} />
                <mesh geometry={nodes.Color_M006_31.geometry} material={nodes.Color_M006_31.material} />
              </group>
              <group position={[526.88, 0, 63.23]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_34'].geometry} material={nodes['Iron_Blurry_5cm#1_34'].material} />
                <mesh geometry={nodes.Color_M006_32.geometry} material={nodes.Color_M006_32.material} />
              </group>
              <group position={[292.71, 0, 35.13]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_35'].geometry} material={nodes['Iron_Blurry_5cm#1_35'].material} />
                <mesh geometry={nodes.Color_M006_33.geometry} material={nodes.Color_M006_33.material} />
              </group>
              <group position={[117.08, 0, 14.05]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_36'].geometry} material={nodes['Iron_Blurry_5cm#1_36'].material} />
                <mesh geometry={nodes.Color_M006_34.geometry} material={nodes.Color_M006_34.material} />
              </group>
              <group position={[234.17, 0, 28.1]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_37'].geometry} material={nodes['Iron_Blurry_5cm#1_37'].material} />
                <mesh geometry={nodes.Color_M006_35.geometry} material={nodes.Color_M006_35.material} />
              </group>
              <group position={[409.79, 0, 49.18]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_38'].geometry} material={nodes['Iron_Blurry_5cm#1_38'].material} />
                <mesh geometry={nodes.Color_M006_36.geometry} material={nodes.Color_M006_36.material} />
              </group>
              <group position={[702.5, 0, 84.3]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_39'].geometry} material={nodes['Iron_Blurry_5cm#1_39'].material} />
                <mesh geometry={nodes.Color_M006_37.geometry} material={nodes.Color_M006_37.material} />
              </group>
              <group position={[995.21, 0, 119.43]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_40'].geometry} material={nodes['Iron_Blurry_5cm#1_40'].material} />
                <mesh geometry={nodes.Color_M006_38.geometry} material={nodes.Color_M006_38.material} />
              </group>
              <group position={[175.63, 0, 21.08]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_41'].geometry} material={nodes['Iron_Blurry_5cm#1_41'].material} />
                <mesh geometry={nodes.Color_M006_39.geometry} material={nodes.Color_M006_39.material} />
              </group>
              <group position={[819.59, 0, 98.35]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_42'].geometry} material={nodes['Iron_Blurry_5cm#1_42'].material} />
                <mesh geometry={nodes.Color_M006_40.geometry} material={nodes.Color_M006_40.material} />
              </group>
              <group position={[761.04, 0, 91.33]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_43'].geometry} material={nodes['Iron_Blurry_5cm#1_43'].material} />
                <mesh geometry={nodes.Color_M006_41.geometry} material={nodes.Color_M006_41.material} />
              </group>
              <group position={[468.33, 0, 56.2]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_44'].geometry} material={nodes['Iron_Blurry_5cm#1_44'].material} />
                <mesh geometry={nodes.Color_M006_42.geometry} material={nodes.Color_M006_42.material} />
              </group>
              <group position={[878.13, 0, 105.38]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_45'].geometry} material={nodes['Iron_Blurry_5cm#1_45'].material} />
                <mesh geometry={nodes.Color_M006_43.geometry} material={nodes.Color_M006_43.material} />
              </group>
              <group position={[1053.75, 0, 126.45]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_46'].geometry} material={nodes['Iron_Blurry_5cm#1_46'].material} />
                <mesh geometry={nodes.Color_M006_44.geometry} material={nodes.Color_M006_44.material} />
              </group>
              <group position={[585.42, 0, 70.25]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_47'].geometry} material={nodes['Iron_Blurry_5cm#1_47'].material} />
                <mesh geometry={nodes.Color_M006_45.geometry} material={nodes.Color_M006_45.material} />
              </group>
              <group position={[58.54, 0, 7.03]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_48'].geometry} material={nodes['Iron_Blurry_5cm#1_48'].material} />
                <mesh geometry={nodes.Color_M006_46.geometry} material={nodes.Color_M006_46.material} />
              </group>
              <group position={[936.67, 0, 112.4]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_49'].geometry} material={nodes['Iron_Blurry_5cm#1_49'].material} />
                <mesh geometry={nodes.Color_M006_47.geometry} material={nodes.Color_M006_47.material} />
              </group>
            </group>
            <group position={[306.88, 148.81, 156.05]} rotation={[0, 0, -Math.PI / 2]}>
              <mesh geometry={nodes['Iron_Blurry_5cm#1_3'].geometry} material={nodes['Iron_Blurry_5cm#1_3'].material} />
              <mesh geometry={nodes.Color_M006_4.geometry} material={nodes.Color_M006_4.material} />
            </group>
            <group position={[1244.15, 210.23, 57.92]} rotation={[0, 0, Math.PI]}>
              <group position={[351.25, 0, 42.15]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_50'].geometry} material={nodes['Iron_Blurry_5cm#1_50'].material} />
                <mesh geometry={nodes.Color_M006_48.geometry} material={nodes.Color_M006_48.material} />
              </group>
              <mesh geometry={nodes['Iron_Blurry_5cm#1_51'].geometry} material={nodes['Iron_Blurry_5cm#1_51'].material} />
              <mesh geometry={nodes.Color_M006_49.geometry} material={nodes.Color_M006_49.material} />
              <group position={[643.96, 0, 77.28]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_52'].geometry} material={nodes['Iron_Blurry_5cm#1_52'].material} />
                <mesh geometry={nodes.Color_M006_50.geometry} material={nodes.Color_M006_50.material} />
              </group>
              <group position={[526.88, 0, 63.23]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_53'].geometry} material={nodes['Iron_Blurry_5cm#1_53'].material} />
                <mesh geometry={nodes.Color_M006_51.geometry} material={nodes.Color_M006_51.material} />
              </group>
              <group position={[292.71, 0, 35.13]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_54'].geometry} material={nodes['Iron_Blurry_5cm#1_54'].material} />
                <mesh geometry={nodes.Color_M006_52.geometry} material={nodes.Color_M006_52.material} />
              </group>
              <group position={[117.08, 0, 14.05]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_55'].geometry} material={nodes['Iron_Blurry_5cm#1_55'].material} />
                <mesh geometry={nodes.Color_M006_53.geometry} material={nodes.Color_M006_53.material} />
              </group>
              <group position={[234.17, 0, 28.1]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_56'].geometry} material={nodes['Iron_Blurry_5cm#1_56'].material} />
                <mesh geometry={nodes.Color_M006_54.geometry} material={nodes.Color_M006_54.material} />
              </group>
              <group position={[409.79, 0, 49.18]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_57'].geometry} material={nodes['Iron_Blurry_5cm#1_57'].material} />
                <mesh geometry={nodes.Color_M006_55.geometry} material={nodes.Color_M006_55.material} />
              </group>
              <group position={[702.5, 0, 84.3]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_58'].geometry} material={nodes['Iron_Blurry_5cm#1_58'].material} />
                <mesh geometry={nodes.Color_M006_56.geometry} material={nodes.Color_M006_56.material} />
              </group>
              <group position={[175.63, 0, 21.08]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_59'].geometry} material={nodes['Iron_Blurry_5cm#1_59'].material} />
                <mesh geometry={nodes.Color_M006_57.geometry} material={nodes.Color_M006_57.material} />
              </group>
              <group position={[819.59, 0, 98.35]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_60'].geometry} material={nodes['Iron_Blurry_5cm#1_60'].material} />
                <mesh geometry={nodes.Color_M006_58.geometry} material={nodes.Color_M006_58.material} />
              </group>
              <group position={[761.04, 0, 91.33]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_61'].geometry} material={nodes['Iron_Blurry_5cm#1_61'].material} />
                <mesh geometry={nodes.Color_M006_59.geometry} material={nodes.Color_M006_59.material} />
              </group>
              <group position={[468.33, 0, 56.2]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_62'].geometry} material={nodes['Iron_Blurry_5cm#1_62'].material} />
                <mesh geometry={nodes.Color_M006_60.geometry} material={nodes.Color_M006_60.material} />
              </group>
              <group position={[585.42, 0, 70.25]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_63'].geometry} material={nodes['Iron_Blurry_5cm#1_63'].material} />
                <mesh geometry={nodes.Color_M006_61.geometry} material={nodes.Color_M006_61.material} />
              </group>
              <group position={[58.54, 0, 7.03]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_64'].geometry} material={nodes['Iron_Blurry_5cm#1_64'].material} />
                <mesh geometry={nodes.Color_M006_62.geometry} material={nodes.Color_M006_62.material} />
              </group>
              <group position={[-58.54, 0, -7.03]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_65'].geometry} material={nodes['Iron_Blurry_5cm#1_65'].material} />
                <mesh geometry={nodes.Color_M006_63.geometry} material={nodes.Color_M006_63.material} />
              </group>
            </group>
            <group position={[1244.15, 144.88, 57.92]} scale={[-1, 1, 1]}>
              <group position={[351.25, 0, 42.15]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_66'].geometry} material={nodes['Iron_Blurry_5cm#1_66'].material} />
                <mesh geometry={nodes.Color_M006_64.geometry} material={nodes.Color_M006_64.material} />
              </group>
              <mesh geometry={nodes['Iron_Blurry_5cm#1_67'].geometry} material={nodes['Iron_Blurry_5cm#1_67'].material} />
              <mesh geometry={nodes.Color_M006_65.geometry} material={nodes.Color_M006_65.material} />
              <group position={[643.96, 0, 77.28]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_68'].geometry} material={nodes['Iron_Blurry_5cm#1_68'].material} />
                <mesh geometry={nodes.Color_M006_66.geometry} material={nodes.Color_M006_66.material} />
              </group>
              <group position={[526.88, 0, 63.23]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_69'].geometry} material={nodes['Iron_Blurry_5cm#1_69'].material} />
                <mesh geometry={nodes.Color_M006_67.geometry} material={nodes.Color_M006_67.material} />
              </group>
              <group position={[292.71, 0, 35.13]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_70'].geometry} material={nodes['Iron_Blurry_5cm#1_70'].material} />
                <mesh geometry={nodes.Color_M006_68.geometry} material={nodes.Color_M006_68.material} />
              </group>
              <group position={[117.08, 0, 14.05]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_71'].geometry} material={nodes['Iron_Blurry_5cm#1_71'].material} />
                <mesh geometry={nodes.Color_M006_69.geometry} material={nodes.Color_M006_69.material} />
              </group>
              <group position={[234.17, 0, 28.1]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_72'].geometry} material={nodes['Iron_Blurry_5cm#1_72'].material} />
                <mesh geometry={nodes.Color_M006_70.geometry} material={nodes.Color_M006_70.material} />
              </group>
              <group position={[409.79, 0, 49.18]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_73'].geometry} material={nodes['Iron_Blurry_5cm#1_73'].material} />
                <mesh geometry={nodes.Color_M006_71.geometry} material={nodes.Color_M006_71.material} />
              </group>
              <group position={[702.5, 0, 84.3]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_74'].geometry} material={nodes['Iron_Blurry_5cm#1_74'].material} />
                <mesh geometry={nodes.Color_M006_72.geometry} material={nodes.Color_M006_72.material} />
              </group>
              <group position={[175.63, 0, 21.08]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_75'].geometry} material={nodes['Iron_Blurry_5cm#1_75'].material} />
                <mesh geometry={nodes.Color_M006_73.geometry} material={nodes.Color_M006_73.material} />
              </group>
              <group position={[819.59, 0, 98.35]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_76'].geometry} material={nodes['Iron_Blurry_5cm#1_76'].material} />
                <mesh geometry={nodes.Color_M006_74.geometry} material={nodes.Color_M006_74.material} />
              </group>
              <group position={[761.04, 0, 91.33]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_77'].geometry} material={nodes['Iron_Blurry_5cm#1_77'].material} />
                <mesh geometry={nodes.Color_M006_75.geometry} material={nodes.Color_M006_75.material} />
              </group>
              <group position={[468.33, 0, 56.2]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_78'].geometry} material={nodes['Iron_Blurry_5cm#1_78'].material} />
                <mesh geometry={nodes.Color_M006_76.geometry} material={nodes.Color_M006_76.material} />
              </group>
              <group position={[585.42, 0, 70.25]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_79'].geometry} material={nodes['Iron_Blurry_5cm#1_79'].material} />
                <mesh geometry={nodes.Color_M006_77.geometry} material={nodes.Color_M006_77.material} />
              </group>
              <group position={[58.54, 0, 7.03]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_80'].geometry} material={nodes['Iron_Blurry_5cm#1_80'].material} />
                <mesh geometry={nodes.Color_M006_78.geometry} material={nodes.Color_M006_78.material} />
              </group>
              <group position={[-58.54, 0, -7.03]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_81'].geometry} material={nodes['Iron_Blurry_5cm#1_81'].material} />
                <mesh geometry={nodes.Color_M006_79.geometry} material={nodes.Color_M006_79.material} />
              </group>
            </group>
            <group position={[352.05, 187.43, 53.14]} rotation={[-Math.PI / 2, 0, -Math.PI]}>
              <mesh geometry={nodes['Concrete_Flooring_H01_2m#1_9'].geometry} material={nodes['Concrete_Flooring_H01_2m#1_9'].material} />
            </group>
            <group position={[369.08, 189.8, 53.9]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
              <mesh geometry={nodes['Concrete_Flooring_H01_2m#1_10'].geometry} material={nodes['Concrete_Flooring_H01_2m#1_10'].material} />
            </group>
            <group position={[370.84, 149.21, 162.88]} rotation={[0, 0, -Math.PI]} scale={[-1, 1, 1]}>
              <group position={[351.25, 0, 42.15]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_82'].geometry} material={nodes['Iron_Blurry_5cm#1_82'].material} />
                <mesh geometry={nodes.Color_M006_80.geometry} material={nodes.Color_M006_80.material} />
              </group>
              <group position={[1112.3, 0, 133.48]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_83'].geometry} material={nodes['Iron_Blurry_5cm#1_83'].material} />
                <mesh geometry={nodes.Color_M006_81.geometry} material={nodes.Color_M006_81.material} />
              </group>
              <mesh geometry={nodes['Iron_Blurry_5cm#1_84'].geometry} material={nodes['Iron_Blurry_5cm#1_84'].material} />
              <mesh geometry={nodes.Color_M006_82.geometry} material={nodes.Color_M006_82.material} />
              <group position={[643.96, 0, 77.28]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_85'].geometry} material={nodes['Iron_Blurry_5cm#1_85'].material} />
                <mesh geometry={nodes.Color_M006_83.geometry} material={nodes.Color_M006_83.material} />
              </group>
              <group position={[526.88, 0, 63.23]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_86'].geometry} material={nodes['Iron_Blurry_5cm#1_86'].material} />
                <mesh geometry={nodes.Color_M006_84.geometry} material={nodes.Color_M006_84.material} />
              </group>
              <group position={[292.71, 0, 35.13]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_87'].geometry} material={nodes['Iron_Blurry_5cm#1_87'].material} />
                <mesh geometry={nodes.Color_M006_85.geometry} material={nodes.Color_M006_85.material} />
              </group>
              <group position={[117.08, 0, 14.05]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_88'].geometry} material={nodes['Iron_Blurry_5cm#1_88'].material} />
                <mesh geometry={nodes.Color_M006_86.geometry} material={nodes.Color_M006_86.material} />
              </group>
              <group position={[234.17, 0, 28.1]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_89'].geometry} material={nodes['Iron_Blurry_5cm#1_89'].material} />
                <mesh geometry={nodes.Color_M006_87.geometry} material={nodes.Color_M006_87.material} />
              </group>
              <group position={[409.79, 0, 49.18]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_90'].geometry} material={nodes['Iron_Blurry_5cm#1_90'].material} />
                <mesh geometry={nodes.Color_M006_88.geometry} material={nodes.Color_M006_88.material} />
              </group>
              <group position={[702.5, 0, 84.3]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_91'].geometry} material={nodes['Iron_Blurry_5cm#1_91'].material} />
                <mesh geometry={nodes.Color_M006_89.geometry} material={nodes.Color_M006_89.material} />
              </group>
              <group position={[995.21, 0, 119.43]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_92'].geometry} material={nodes['Iron_Blurry_5cm#1_92'].material} />
                <mesh geometry={nodes.Color_M006_90.geometry} material={nodes.Color_M006_90.material} />
              </group>
              <group position={[175.63, 0, 21.08]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_93'].geometry} material={nodes['Iron_Blurry_5cm#1_93'].material} />
                <mesh geometry={nodes.Color_M006_91.geometry} material={nodes.Color_M006_91.material} />
              </group>
              <group position={[819.59, 0, 98.35]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_94'].geometry} material={nodes['Iron_Blurry_5cm#1_94'].material} />
                <mesh geometry={nodes.Color_M006_92.geometry} material={nodes.Color_M006_92.material} />
              </group>
              <group position={[761.04, 0, 91.33]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_95'].geometry} material={nodes['Iron_Blurry_5cm#1_95'].material} />
                <mesh geometry={nodes.Color_M006_93.geometry} material={nodes.Color_M006_93.material} />
              </group>
              <group position={[468.33, 0, 56.2]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_96'].geometry} material={nodes['Iron_Blurry_5cm#1_96'].material} />
                <mesh geometry={nodes.Color_M006_94.geometry} material={nodes.Color_M006_94.material} />
              </group>
              <group position={[878.13, 0, 105.38]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_97'].geometry} material={nodes['Iron_Blurry_5cm#1_97'].material} />
                <mesh geometry={nodes.Color_M006_95.geometry} material={nodes.Color_M006_95.material} />
              </group>
              <group position={[1053.75, 0, 126.45]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_98'].geometry} material={nodes['Iron_Blurry_5cm#1_98'].material} />
                <mesh geometry={nodes.Color_M006_96.geometry} material={nodes.Color_M006_96.material} />
              </group>
              <group position={[585.42, 0, 70.25]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_99'].geometry} material={nodes['Iron_Blurry_5cm#1_99'].material} />
                <mesh geometry={nodes.Color_M006_97.geometry} material={nodes.Color_M006_97.material} />
              </group>
              <group position={[58.54, 0, 7.03]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_100'].geometry} material={nodes['Iron_Blurry_5cm#1_100'].material} />
                <mesh geometry={nodes.Color_M006_98.geometry} material={nodes.Color_M006_98.material} />
              </group>
              <group position={[936.67, 0, 112.4]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_101'].geometry} material={nodes['Iron_Blurry_5cm#1_101'].material} />
                <mesh geometry={nodes.Color_M006_99.geometry} material={nodes.Color_M006_99.material} />
              </group>
            </group>
            <mesh geometry={nodes['Concrete_Flooring_H01_2m#1'].geometry} material={nodes['Concrete_Flooring_H01_2m#1'].material} />
            <group position={[4050.74, 0, 0.01]} scale={[-0.99, 1, 1]}>
              <group position={[370.84, 83.85, 162.88]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_4'].geometry} material={nodes['Iron_Blurry_5cm#1_4'].material} />
                <mesh geometry={nodes.Color_M006_5.geometry} material={nodes.Color_M006_5.material} />
              </group>
              <group position={[1190.43, 83.85, 261.24]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_5'].geometry} material={nodes['Iron_Blurry_5cm#1_5'].material} />
                <mesh geometry={nodes.Color_M006_6.geometry} material={nodes.Color_M006_6.material} />
              </group>
              <group position={[1483.14, 83.85, 296.36]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_6'].geometry} material={nodes['Iron_Blurry_5cm#1_6'].material} />
              </group>
              <group position={[897.72, 83.85, 226.11]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_7'].geometry} material={nodes['Iron_Blurry_5cm#1_7'].material} />
                <mesh geometry={nodes.Color_M006_7.geometry} material={nodes.Color_M006_7.material} />
              </group>
              <group position={[1248.97, 83.85, 268.26]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_8'].geometry} material={nodes['Iron_Blurry_5cm#1_8'].material} />
                <mesh geometry={nodes.Color_M006_8.geometry} material={nodes.Color_M006_8.material} />
              </group>
              <group position={[663.55, 83.85, 198.01]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_9'].geometry} material={nodes['Iron_Blurry_5cm#1_9'].material} />
                <mesh geometry={nodes.Color_M006_9.geometry} material={nodes.Color_M006_9.material} />
              </group>
              <group position={[1073.34, 83.85, 247.19]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_10'].geometry} material={nodes['Iron_Blurry_5cm#1_10'].material} />
                <mesh geometry={nodes.Color_M006_10.geometry} material={nodes.Color_M006_10.material} />
              </group>
              <group position={[1424.59, 83.85, 289.34]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_11'].geometry} material={nodes['Iron_Blurry_5cm#1_11'].material} />
                <mesh geometry={nodes.Color_M006_11.geometry} material={nodes.Color_M006_11.material} />
              </group>
              <group position={[1366.05, 83.85, 282.31]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_12'].geometry} material={nodes['Iron_Blurry_5cm#1_12'].material} />
                <mesh geometry={nodes.Color_M006_12.geometry} material={nodes.Color_M006_12.material} />
              </group>
              <group position={[839.18, 83.85, 219.09]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_13'].geometry} material={nodes['Iron_Blurry_5cm#1_13'].material} />
                <mesh geometry={nodes.Color_M006_13.geometry} material={nodes.Color_M006_13.material} />
              </group>
              <group position={[1014.8, 83.85, 240.16]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_14'].geometry} material={nodes['Iron_Blurry_5cm#1_14'].material} />
                <mesh geometry={nodes.Color_M006_14.geometry} material={nodes.Color_M006_14.material} />
              </group>
              <group position={[487.92, 83.85, 176.93]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_15'].geometry} material={nodes['Iron_Blurry_5cm#1_15'].material} />
                <mesh geometry={nodes.Color_M006_15.geometry} material={nodes.Color_M006_15.material} />
              </group>
              <group position={[956.26, 83.85, 233.13]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_16'].geometry} material={nodes['Iron_Blurry_5cm#1_16'].material} />
                <mesh geometry={nodes.Color_M006_16.geometry} material={nodes.Color_M006_16.material} />
              </group>
              <group position={[1307.51, 83.85, 275.29]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_17'].geometry} material={nodes['Iron_Blurry_5cm#1_17'].material} />
                <mesh geometry={nodes.Color_M006_17.geometry} material={nodes.Color_M006_17.material} />
              </group>
              <group position={[605.01, 83.85, 190.99]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_18'].geometry} material={nodes['Iron_Blurry_5cm#1_18'].material} />
                <mesh geometry={nodes.Color_M006_18.geometry} material={nodes.Color_M006_18.material} />
              </group>
              <group position={[546.47, 83.85, 183.96]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_19'].geometry} material={nodes['Iron_Blurry_5cm#1_19'].material} />
                <mesh geometry={nodes.Color_M006_19.geometry} material={nodes.Color_M006_19.material} />
              </group>
              <group position={[1131.89, 83.85, 254.21]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_20'].geometry} material={nodes['Iron_Blurry_5cm#1_20'].material} />
                <mesh geometry={nodes.Color_M006_20.geometry} material={nodes.Color_M006_20.material} />
              </group>
              <group position={[780.63, 83.85, 212.06]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_21'].geometry} material={nodes['Iron_Blurry_5cm#1_21'].material} />
                <mesh geometry={nodes.Color_M006_21.geometry} material={nodes.Color_M006_21.material} />
              </group>
              <group position={[722.09, 83.85, 205.04]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_22'].geometry} material={nodes['Iron_Blurry_5cm#1_22'].material} />
                <mesh geometry={nodes.Color_M006_22.geometry} material={nodes.Color_M006_22.material} />
              </group>
              <group position={[429.38, 83.85, 169.91]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_23'].geometry} material={nodes['Iron_Blurry_5cm#1_23'].material} />
                <mesh geometry={nodes.Color_M006_23.geometry} material={nodes.Color_M006_23.material} />
              </group>
              <group position={[2595.42, 149.21, 296.36]} rotation={[0, 0, Math.PI]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_24'].geometry} material={nodes['Iron_Blurry_5cm#1_24'].material} />
              </group>
              <group position={[1483.14, 83.85, 296.36]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_25'].geometry} material={nodes['Iron_Blurry_5cm#1_25'].material} />
                <mesh geometry={nodes.Color_M006_24.geometry} material={nodes.Color_M006_24.material} />
              </group>
              <group position={[947.31, 128.5, 121.82]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
                <mesh geometry={nodes['Concrete_Flooring_H01_2m#1_11'].geometry} material={nodes['Concrete_Flooring_H01_2m#1_11'].material} />
              </group>
              <group position={[570.63, 163.78, 132.23]} rotation={[-Math.PI, -1.45, Math.PI / 2]}>
                <mesh geometry={nodes['Concrete_Flooring_H01_2m#1_12'].geometry} material={nodes['Concrete_Flooring_H01_2m#1_12'].material} />
              </group>
              <group position={[386.8, 1071.25, 108.42]} rotation={[-Math.PI / 2, 0, Math.PI]}>
                <mesh geometry={nodes['Concrete_Flooring_H01_2m#1_13'].geometry} material={nodes['Concrete_Flooring_H01_2m#1_13'].material} />
              </group>
              <group position={[-15.72, 163.78, 61.87]} rotation={[-Math.PI, -1.45, Math.PI / 2]}>
                <mesh geometry={nodes['Concrete_Flooring_H01_2m#1_14'].geometry} material={nodes['Concrete_Flooring_H01_2m#1_14'].material} />
              </group>
              <group position={[310.03, 83.85, 156.05]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_26'].geometry} material={nodes['Iron_Blurry_5cm#1_26'].material} />
              </group>
              <group position={[306.88, 207.08, 156.05]} rotation={[0, 0, -Math.PI / 2]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_27'].geometry} material={nodes['Iron_Blurry_5cm#1_27'].material} />
                <mesh geometry={nodes.Color_M006_25.geometry} material={nodes.Color_M006_25.material} />
              </group>
              <group position={[371.84, 210.23, 156.05]} rotation={[0, 0, Math.PI]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_28'].geometry} material={nodes['Iron_Blurry_5cm#1_28'].material} />
                <mesh geometry={nodes.Color_M006_26.geometry} material={nodes.Color_M006_26.material} />
              </group>
              <group position={[-27.92, 224.8, 156.08]} rotation={[0, -1.45, -Math.PI / 2]}>
                <mesh geometry={nodes['Concrete_Flooring_H01_2m#1_15'].geometry} material={nodes['Concrete_Flooring_H01_2m#1_15'].material} />
              </group>
              <group position={[352.05, 126.36, 53.14]} rotation={[-Math.PI / 2, 0, -Math.PI]}>
                <mesh geometry={nodes['Concrete_Flooring_H01_2m#1_16'].geometry} material={nodes['Concrete_Flooring_H01_2m#1_16'].material} />
              </group>
              <group position={[369.08, 128.73, 53.94]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
                <mesh geometry={nodes['Concrete_Flooring_H01_2m#1_17'].geometry} material={nodes['Concrete_Flooring_H01_2m#1_17'].material} />
              </group>
              <group position={[306.88, 148.81, 156.05]} rotation={[0, 0, -Math.PI / 2]}>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_29'].geometry} material={nodes['Iron_Blurry_5cm#1_29'].material} />
                <mesh geometry={nodes.Color_M006_27.geometry} material={nodes.Color_M006_27.material} />
              </group>
              <group position={[1244.15, 210.23, 57.92]} rotation={[0, 0, Math.PI]}>
                <group position={[351.25, 0, 42.15]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_102'].geometry} material={nodes['Iron_Blurry_5cm#1_102'].material} />
                  <mesh geometry={nodes.Color_M006_100.geometry} material={nodes.Color_M006_100.material} />
                </group>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_103'].geometry} material={nodes['Iron_Blurry_5cm#1_103'].material} />
                <mesh geometry={nodes.Color_M006_101.geometry} material={nodes.Color_M006_101.material} />
                <group position={[643.96, 0, 77.28]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_104'].geometry} material={nodes['Iron_Blurry_5cm#1_104'].material} />
                  <mesh geometry={nodes.Color_M006_102.geometry} material={nodes.Color_M006_102.material} />
                </group>
                <group position={[526.88, 0, 63.23]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_105'].geometry} material={nodes['Iron_Blurry_5cm#1_105'].material} />
                  <mesh geometry={nodes.Color_M006_103.geometry} material={nodes.Color_M006_103.material} />
                </group>
                <group position={[292.71, 0, 35.13]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_106'].geometry} material={nodes['Iron_Blurry_5cm#1_106'].material} />
                  <mesh geometry={nodes.Color_M006_104.geometry} material={nodes.Color_M006_104.material} />
                </group>
                <group position={[117.08, 0, 14.05]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_107'].geometry} material={nodes['Iron_Blurry_5cm#1_107'].material} />
                  <mesh geometry={nodes.Color_M006_105.geometry} material={nodes.Color_M006_105.material} />
                </group>
                <group position={[234.17, 0, 28.1]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_108'].geometry} material={nodes['Iron_Blurry_5cm#1_108'].material} />
                  <mesh geometry={nodes.Color_M006_106.geometry} material={nodes.Color_M006_106.material} />
                </group>
                <group position={[409.79, 0, 49.18]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_109'].geometry} material={nodes['Iron_Blurry_5cm#1_109'].material} />
                  <mesh geometry={nodes.Color_M006_107.geometry} material={nodes.Color_M006_107.material} />
                </group>
                <group position={[702.5, 0, 84.3]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_110'].geometry} material={nodes['Iron_Blurry_5cm#1_110'].material} />
                  <mesh geometry={nodes.Color_M006_108.geometry} material={nodes.Color_M006_108.material} />
                </group>
                <group position={[175.63, 0, 21.08]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_111'].geometry} material={nodes['Iron_Blurry_5cm#1_111'].material} />
                  <mesh geometry={nodes.Color_M006_109.geometry} material={nodes.Color_M006_109.material} />
                </group>
                <group position={[819.59, 0, 98.35]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_112'].geometry} material={nodes['Iron_Blurry_5cm#1_112'].material} />
                  <mesh geometry={nodes.Color_M006_110.geometry} material={nodes.Color_M006_110.material} />
                </group>
                <group position={[761.04, 0, 91.33]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_113'].geometry} material={nodes['Iron_Blurry_5cm#1_113'].material} />
                  <mesh geometry={nodes.Color_M006_111.geometry} material={nodes.Color_M006_111.material} />
                </group>
                <group position={[468.33, 0, 56.2]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_114'].geometry} material={nodes['Iron_Blurry_5cm#1_114'].material} />
                  <mesh geometry={nodes.Color_M006_112.geometry} material={nodes.Color_M006_112.material} />
                </group>
                <group position={[585.42, 0, 70.25]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_115'].geometry} material={nodes['Iron_Blurry_5cm#1_115'].material} />
                  <mesh geometry={nodes.Color_M006_113.geometry} material={nodes.Color_M006_113.material} />
                </group>
                <group position={[58.54, 0, 7.03]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_116'].geometry} material={nodes['Iron_Blurry_5cm#1_116'].material} />
                  <mesh geometry={nodes.Color_M006_114.geometry} material={nodes.Color_M006_114.material} />
                </group>
                <group position={[-58.54, 0, -7.03]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_117'].geometry} material={nodes['Iron_Blurry_5cm#1_117'].material} />
                  <mesh geometry={nodes.Color_M006_115.geometry} material={nodes.Color_M006_115.material} />
                </group>
              </group>
              <group position={[1244.15, 144.88, 57.92]} scale={[-1, 1, 1]}>
                <group position={[351.25, 0, 42.15]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_118'].geometry} material={nodes['Iron_Blurry_5cm#1_118'].material} />
                  <mesh geometry={nodes.Color_M006_116.geometry} material={nodes.Color_M006_116.material} />
                </group>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_119'].geometry} material={nodes['Iron_Blurry_5cm#1_119'].material} />
                <mesh geometry={nodes.Color_M006_117.geometry} material={nodes.Color_M006_117.material} />
                <group position={[643.96, 0, 77.28]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_120'].geometry} material={nodes['Iron_Blurry_5cm#1_120'].material} />
                  <mesh geometry={nodes.Color_M006_118.geometry} material={nodes.Color_M006_118.material} />
                </group>
                <group position={[526.88, 0, 63.23]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_121'].geometry} material={nodes['Iron_Blurry_5cm#1_121'].material} />
                  <mesh geometry={nodes.Color_M006_119.geometry} material={nodes.Color_M006_119.material} />
                </group>
                <group position={[292.71, 0, 35.13]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_122'].geometry} material={nodes['Iron_Blurry_5cm#1_122'].material} />
                  <mesh geometry={nodes.Color_M006_120.geometry} material={nodes.Color_M006_120.material} />
                </group>
                <group position={[117.08, 0, 14.05]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_123'].geometry} material={nodes['Iron_Blurry_5cm#1_123'].material} />
                  <mesh geometry={nodes.Color_M006_121.geometry} material={nodes.Color_M006_121.material} />
                </group>
                <group position={[234.17, 0, 28.1]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_124'].geometry} material={nodes['Iron_Blurry_5cm#1_124'].material} />
                  <mesh geometry={nodes.Color_M006_122.geometry} material={nodes.Color_M006_122.material} />
                </group>
                <group position={[409.79, 0, 49.18]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_125'].geometry} material={nodes['Iron_Blurry_5cm#1_125'].material} />
                  <mesh geometry={nodes.Color_M006_123.geometry} material={nodes.Color_M006_123.material} />
                </group>
                <group position={[702.5, 0, 84.3]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_126'].geometry} material={nodes['Iron_Blurry_5cm#1_126'].material} />
                  <mesh geometry={nodes.Color_M006_124.geometry} material={nodes.Color_M006_124.material} />
                </group>
                <group position={[175.63, 0, 21.08]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_127'].geometry} material={nodes['Iron_Blurry_5cm#1_127'].material} />
                  <mesh geometry={nodes.Color_M006_125.geometry} material={nodes.Color_M006_125.material} />
                </group>
                <group position={[819.59, 0, 98.35]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_128'].geometry} material={nodes['Iron_Blurry_5cm#1_128'].material} />
                  <mesh geometry={nodes.Color_M006_126.geometry} material={nodes.Color_M006_126.material} />
                </group>
                <group position={[761.04, 0, 91.33]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_129'].geometry} material={nodes['Iron_Blurry_5cm#1_129'].material} />
                  <mesh geometry={nodes.Color_M006_127.geometry} material={nodes.Color_M006_127.material} />
                </group>
                <group position={[468.33, 0, 56.2]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_130'].geometry} material={nodes['Iron_Blurry_5cm#1_130'].material} />
                  <mesh geometry={nodes.Color_M006_128.geometry} material={nodes.Color_M006_128.material} />
                </group>
                <group position={[585.42, 0, 70.25]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_131'].geometry} material={nodes['Iron_Blurry_5cm#1_131'].material} />
                  <mesh geometry={nodes.Color_M006_129.geometry} material={nodes.Color_M006_129.material} />
                </group>
                <group position={[58.54, 0, 7.03]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_132'].geometry} material={nodes['Iron_Blurry_5cm#1_132'].material} />
                  <mesh geometry={nodes.Color_M006_130.geometry} material={nodes.Color_M006_130.material} />
                </group>
                <group position={[-58.54, 0, -7.03]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_133'].geometry} material={nodes['Iron_Blurry_5cm#1_133'].material} />
                  <mesh geometry={nodes.Color_M006_131.geometry} material={nodes.Color_M006_131.material} />
                </group>
              </group>
              <group position={[352.05, 187.43, 53.14]} rotation={[-Math.PI / 2, 0, -Math.PI]}>
                <mesh geometry={nodes['Concrete_Flooring_H01_2m#1_18'].geometry} material={nodes['Concrete_Flooring_H01_2m#1_18'].material} />
              </group>
              <group position={[369.08, 189.8, 53.9]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
                <mesh geometry={nodes['Concrete_Flooring_H01_2m#1_19'].geometry} material={nodes['Concrete_Flooring_H01_2m#1_19'].material} />
              </group>
              <group position={[370.84, 149.21, 162.88]} rotation={[0, 0, -Math.PI]} scale={[-1, 1, 1]}>
                <group position={[351.25, 0, 42.15]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_134'].geometry} material={nodes['Iron_Blurry_5cm#1_134'].material} />
                  <mesh geometry={nodes.Color_M006_132.geometry} material={nodes.Color_M006_132.material} />
                </group>
                <group position={[1112.3, 0, 133.48]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_135'].geometry} material={nodes['Iron_Blurry_5cm#1_135'].material} />
                  <mesh geometry={nodes.Color_M006_133.geometry} material={nodes.Color_M006_133.material} />
                </group>
                <mesh geometry={nodes['Iron_Blurry_5cm#1_136'].geometry} material={nodes['Iron_Blurry_5cm#1_136'].material} />
                <mesh geometry={nodes.Color_M006_134.geometry} material={nodes.Color_M006_134.material} />
                <group position={[643.96, 0, 77.28]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_137'].geometry} material={nodes['Iron_Blurry_5cm#1_137'].material} />
                  <mesh geometry={nodes.Color_M006_135.geometry} material={nodes.Color_M006_135.material} />
                </group>
                <group position={[526.88, 0, 63.23]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_138'].geometry} material={nodes['Iron_Blurry_5cm#1_138'].material} />
                  <mesh geometry={nodes.Color_M006_136.geometry} material={nodes.Color_M006_136.material} />
                </group>
                <group position={[292.71, 0, 35.13]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_139'].geometry} material={nodes['Iron_Blurry_5cm#1_139'].material} />
                  <mesh geometry={nodes.Color_M006_137.geometry} material={nodes.Color_M006_137.material} />
                </group>
                <group position={[117.08, 0, 14.05]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_140'].geometry} material={nodes['Iron_Blurry_5cm#1_140'].material} />
                  <mesh geometry={nodes.Color_M006_138.geometry} material={nodes.Color_M006_138.material} />
                </group>
                <group position={[234.17, 0, 28.1]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_141'].geometry} material={nodes['Iron_Blurry_5cm#1_141'].material} />
                  <mesh geometry={nodes.Color_M006_139.geometry} material={nodes.Color_M006_139.material} />
                </group>
                <group position={[409.79, 0, 49.18]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_142'].geometry} material={nodes['Iron_Blurry_5cm#1_142'].material} />
                  <mesh geometry={nodes.Color_M006_140.geometry} material={nodes.Color_M006_140.material} />
                </group>
                <group position={[702.5, 0, 84.3]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_143'].geometry} material={nodes['Iron_Blurry_5cm#1_143'].material} />
                  <mesh geometry={nodes.Color_M006_141.geometry} material={nodes.Color_M006_141.material} />
                </group>
                <group position={[995.21, 0, 119.43]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_144'].geometry} material={nodes['Iron_Blurry_5cm#1_144'].material} />
                  <mesh geometry={nodes.Color_M006_142.geometry} material={nodes.Color_M006_142.material} />
                </group>
                <group position={[175.63, 0, 21.08]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_145'].geometry} material={nodes['Iron_Blurry_5cm#1_145'].material} />
                  <mesh geometry={nodes.Color_M006_143.geometry} material={nodes.Color_M006_143.material} />
                </group>
                <group position={[819.59, 0, 98.35]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_146'].geometry} material={nodes['Iron_Blurry_5cm#1_146'].material} />
                  <mesh geometry={nodes.Color_M006_144.geometry} material={nodes.Color_M006_144.material} />
                </group>
                <group position={[761.04, 0, 91.33]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_147'].geometry} material={nodes['Iron_Blurry_5cm#1_147'].material} />
                  <mesh geometry={nodes.Color_M006_145.geometry} material={nodes.Color_M006_145.material} />
                </group>
                <group position={[468.33, 0, 56.2]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_148'].geometry} material={nodes['Iron_Blurry_5cm#1_148'].material} />
                  <mesh geometry={nodes.Color_M006_146.geometry} material={nodes.Color_M006_146.material} />
                </group>
                <group position={[878.13, 0, 105.38]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_149'].geometry} material={nodes['Iron_Blurry_5cm#1_149'].material} />
                  <mesh geometry={nodes.Color_M006_147.geometry} material={nodes.Color_M006_147.material} />
                </group>
                <group position={[1053.75, 0, 126.45]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_150'].geometry} material={nodes['Iron_Blurry_5cm#1_150'].material} />
                  <mesh geometry={nodes.Color_M006_148.geometry} material={nodes.Color_M006_148.material} />
                </group>
                <group position={[585.42, 0, 70.25]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_151'].geometry} material={nodes['Iron_Blurry_5cm#1_151'].material} />
                  <mesh geometry={nodes.Color_M006_149.geometry} material={nodes.Color_M006_149.material} />
                </group>
                <group position={[58.54, 0, 7.03]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_152'].geometry} material={nodes['Iron_Blurry_5cm#1_152'].material} />
                  <mesh geometry={nodes.Color_M006_150.geometry} material={nodes.Color_M006_150.material} />
                </group>
                <group position={[936.67, 0, 112.4]}>
                  <mesh geometry={nodes['Iron_Blurry_5cm#1_153'].geometry} material={nodes['Iron_Blurry_5cm#1_153'].material} />
                  <mesh geometry={nodes.Color_M006_151.geometry} material={nodes.Color_M006_151.material} />
                </group>
              </group>
              <mesh geometry={nodes['Concrete_Flooring_H01_2m#1_1'].geometry} material={nodes['Concrete_Flooring_H01_2m#1_1'].material} />
              <mesh geometry={nodes.Color_M006_1.geometry} material={nodes.Color_M006_1.material} />
            </group>
            <group position={[1532.05, 87, 43.46]}>
              <group position={[0, 41.88, 150.4]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
                <mesh geometry={nodes['Concrete_Flooring_H01_2m#1_20'].geometry} material={nodes['Concrete_Flooring_H01_2m#1_20'].material} />
              </group>
              <group position={[984.13, 41.88, 150.4]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
                <mesh geometry={nodes['Concrete_Flooring_H01_2m#1_21'].geometry} material={nodes['Concrete_Flooring_H01_2m#1_21'].material} />
              </group>
              <group position={[9.72, 76.78, 205.68]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
                <mesh geometry={nodes['Concrete_Flooring_H01_2m#1_22'].geometry} material={nodes['Concrete_Flooring_H01_2m#1_22'].material} />
              </group>
            </group>
          </group>
          <mesh geometry={nodes.Asphalt_New.geometry} material={nodes.Asphalt_New.material} />
          <mesh geometry={nodes.Blacktop_Old_01.geometry} material={nodes.Blacktop_Old_01.material} />
          <mesh geometry={nodes.Blacktop_Old_02.geometry} material={nodes.Blacktop_Old_02.material} />
          <mesh geometry={nodes.Color_M006.geometry} material={nodes.Color_M006.material} />
          <mesh geometry={nodes.Grass_Dark_Green.geometry} material={nodes.Grass_Dark_Green.material} />
        </group>
        <group position={[61.12, 32.43, 0]}>
          <group position={[-1969.13, -3790.53, 43.46]} rotation={[0, 0, 0.44]}>
            <mesh geometry={nodes.Asphalt_New_1.geometry} material={nodes.Asphalt_New_1.material} />
          </group>
        </group>
      </group>
      <PerspectiveCamera makeDefault={false} far={0.1} near={0} fov={13} position={[0, 0, -10]} rotation={[-Math.PI, 0, -Math.PI]} />
      <PerspectiveCamera makeDefault={false} far={3723.93} near={339.71} fov={49.5} position={[-1334.95, -980.15, 595.92]} rotation={[1.35, -0.3, -0.07]} />
      <PerspectiveCamera makeDefault={false} far={3371.44} near={0} fov={49.5} position={[1920.58, 1550.52, -61.89]} rotation={[Math.PI / 2, 0.8, 0]} />
      <PerspectiveCamera makeDefault={false} far={2326.22} near={0} fov={49.5} position={[956.07, 1452.02, -22.71]} rotation={[1.68, 0.71, -0.07]} />
      <PerspectiveCamera makeDefault={false} far={1432.04} near={0} fov={49.5} position={[-18.14, 1543.69, -59.24]} rotation={[1.71, 0.66, -0.09]} />
      <PerspectiveCamera makeDefault={false} far={5928.75} near={0} fov={49.5} position={[-1843.52, 2554.48, -36.4]} rotation={[-1.63, -0.81, 3.1]} />
      <PerspectiveCamera makeDefault={false} far={3546.65} near={0} fov={49.5} position={[723.09, 2070.03, -83.86]} rotation={[-1.8, -1.37, 2.92]} />
      <PerspectiveCamera makeDefault={false} far={4176.21} near={2634.12} fov={49.5} position={[105.3, 3793.94, -73.95]} rotation={[-1.66, 0.11, -3.13]} />
    </group>
  )
}

